export default [
    {
        path: '/mollie/transactions-list',
        name: 'mollie_transactions_list',
        component: () => import('@src/mollie/mollie-transaction-list.vue'),
        meta: {
            title: 'Kontoauszug Mollie',
            role: 'ROLE_PAYMENT_MATCHING',
        },
    },
    {
        path: '/mollie/transaction-matching/:id',
        name: 'mollie_transaction_matching',
        component: () => import('@src/mollie/mollie-transaction-matching.vue'),
        props(route: any) {
            return { id: Number.parseInt(route.params.id) };
        },
        meta: {
            title: 'Kontoauszugszuordnung Mollie',
            role: 'ROLE_PAYMENT_MATCHING',
        },
    },
    {
        path: '/mollie/transaction-detail/:id',
        name: 'mollie_transaction_detail',
        component: () => import('@src/mollie/mollie-transaction-detail.vue'),
        props(route: any) {
            return { id: Number.parseInt(route.params.id) };
        },
        meta: {
            title: 'Kontoauszugszeile Mollie',
            role: 'ROLE_MOLLIE_TRANSACTION',
        },
    },
];
